import * as api from "../../utils/api";
import { showLoading, hideLoading } from "react-redux-loading";
import { updateQuestions } from "./userActions";
import { formatQuestion } from "../../utils/helper";
import { Action } from "redux";

export const ALL_QUESTIONS = "ALL_QUESTIONS";
export const ADD_QUESTION = "ADD_QUESTION";
export const UPDATE_ANSWERS = "UPDATE_ANSWERS";

export const updateAnswers = (info:any) => {
  return {
    type: UPDATE_ANSWERS,
    info,
  };
};

export const saveQuestionAnswer = (info:any) => {
  return (dispatch:any) => {
    dispatch(showLoading());
    dispatch(updateAnswers(info));
    api.saveQuestionAnswer({
        authedUser: info.author,
        qid: info.questionId,
        answer: info.selectedOption,
      })
      .then(() => {
        dispatch(hideLoading());
      })
      .catch(() => dispatch(hideLoading()));
  };
};

export const addQuestion = (info:any) => {
  return {
    type: ADD_QUESTION,
    info,
  };
};

const allQuestions = (questions:any) => {
  return {
    type: ALL_QUESTIONS,
    allQuestions: questions,
  };
};

export const addNewQuestion = (info:any) => {
  return (dispatch: (arg0: Action<any>) => void) => {
    dispatch(showLoading());
    const question = formatQuestion(info);
    dispatch(addQuestion(info));
    dispatch(updateQuestions(info));
    api.saveQuestion(question)
      .then(() => {
        dispatch(hideLoading());
      })
      .catch(() => dispatch(hideLoading()));
  };
};

export const getAllQuestions = () => {
  return (dispatch: (arg0: Action<any>) => void, getState: () => { (): any; new(): any; questionReducer: { (): any; new(): any; allQuestions: { (): any; new(): any; length: number; }; }; }) => {
    if (getState().questionReducer.allQuestions.length > 0) return;

    dispatch(showLoading());
    api.getQuestions()
      .then((data:any) => {
        dispatch(hideLoading());
        let questionsResult = Object.keys(data).map((key:any) => data[key]);

        dispatch(allQuestions(questionsResult));
      })
      .catch(() => {
        dispatch(hideLoading());
        alert("There was an error. Try again");
      });
  };
};
